<div *ngIf="quoteData">
  <ul ngbNav #tabs="ngbNav" class="nav-tabs">
    <li ngbNavItem="form">
      <a ngbNavLink>Form</a>
      <ng-template ngbNavContent>
        <br />
        <app-budget-form
          [quoteData]="quoteData"
          (quoteDataChange)="quoteSessionService.setQuoteData($event)"
          (submit)="onSubmit()"
          (reset)="newBudget()"
          (success)="onSuccess($event)"
        >
        </app-budget-form>
      </ng-template>
    </li>
    <li
      ngbNavItem="result"
      [disabled]="!resultEnabled"
      (shown)="dwgReady = true"
      (hidden)="dwgReady = false"
    >
      <a ngbNavLink>Result</a>
      <ng-template ngbNavContent>
        <br />
        <app-budget-result
          *ngIf="dwgReady"
          [quoteData]="quoteData"
          [backsheet]="quoteSessionService.backsheet | async"
          [drawing]="quoteSessionService.drawing | async"
          [budgetQuoteId]="budgetQuoteId"
        >
        </app-budget-result>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="tabs"></div>
</div>
